import { Debt } from '../../interfaces';

export const isCurrentBalanceGreaterThan = (debt: Debt, threshold = 500): boolean =>
  debt.currentBalance !== null && debt.currentBalance >= threshold;
